import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Divider, Grid, Tab, Tabs, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoNotDisturbAltOutlinedIcon from '@mui/icons-material/DoNotDisturbAltOutlined';
import ThumbUpOffAltOutlinedIcon from '@mui/icons-material/ThumbUpOffAltOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { TabContext, TabPanel } from '@mui/lab';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { styles } from './styles';
import AllChangeRequests from './AllRequests';
import ApproverChangeRequests from './ApproverChangeRequests';
import { resetController, setController, setInitialFilters } from '../../store/slices/tableController';
import StatusCard from '../../components/common/StatusUI/StatusCard';

const views = [
    {
        label: 'Change Requests',
        value: 'change-requests',
    },
    {
        label: 'Approval Requests',
        value: 'approval-requests',
    },
];

const icons = {
    Active: CheckCircleOutlineIcon,
    Approved: ThumbUpOffAltOutlinedIcon,
    Rejected: DoNotDisturbAltOutlinedIcon,
    Cancelled: CloseOutlinedIcon,
};

const ChangeRequests = () => {
    const [crStatus, setCRStatus] = useState({});
    const [searchParams] = useSearchParams();
    const urlType = searchParams && searchParams.get('type');
    const [view, setView] = useState(urlType || 'change-requests');
    const controller = useSelector((state) => state.tableController);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(
            setInitialFilters([
                {
                    property: {
                        name: 'p',
                        type: 'string',
                    },
                    operator: {
                        value: '',
                        typesAccepted: [],
                    },
                    value: '',
                },
            ]),
        );
    }, []);

    const handleTabNavigation = (value) => {
        setView(value);
        navigate(`?type=${value}`);
    };

    useEffect(() => {
        handleStatusFilter();
    }, [view]);

    const handleStatusFilter = (value) => {
        if (!value)
            return dispatch(
                resetController({
                    initialFilters: [
                        {
                            property: {
                                name: 'p',
                                type: 'string',
                            },
                            operator: {
                                value: '',
                                typesAccepted: [],
                            },
                            value: '',
                        },
                    ],
                }),
            );
        else
            dispatch(
                setController({
                    page: 0,
                    filters: [
                        {
                            operator: '',
                            property: 's',
                            value: value,
                        },
                    ],
                    initialFilters: [
                        {
                            property: {
                                name: 's',
                                type: 'string',
                            },
                            operator: {
                                value: '',
                                typesAccepted: [],
                            },
                            value: value,
                        },
                    ],
                    searched: true,
                }),
            );
    };

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Change Requests</Typography>
            </Box>
            <Grid
                sx={{
                    pt: '0 !important',
                    pb: '32px',
                }}
                item
                container
                spacing={3}
                justifyContent="flex-start"
                alignItems="stretch"
                columns={12}
            >
                {['Active', 'Approved', 'Rejected', 'Cancelled'].map((item) => {
                    const filteredStatus = controller.filters?.find((item) => item.property === 's')?.value;
                    return (
                        <Grid item xs={3} sm={3} md={3} lg={3}>
                            <StatusCard
                                Icon={icons[item]}
                                label={item}
                                filteredStatus={filteredStatus}
                                value={crStatus?.[item]}
                                handleStatusFilter={view === 'change-requests' && handleStatusFilter}
                            />
                        </Grid>
                    );
                })}
            </Grid>
            <Box sx={styles.contentBodyWrapper}>
                <Card>
                    <CardContent>
                        <TabContext value={view}>
                            <Box>
                                <Tabs
                                    value={view}
                                    onChange={(event, value) => handleTabNavigation(value)}
                                    aria-label="basic tabs example"
                                >
                                    {views.map((option) => (
                                        <Tab
                                            key={option.label}
                                            disabled={false}
                                            label={option.label}
                                            value={option.value}
                                        />
                                    ))}
                                </Tabs>
                                <Divider />
                            </Box>
                            <TabPanel
                                sx={{
                                    pr: 0,
                                    pl: 0,
                                    pt: 0,
                                }}
                                value={'change-requests'}
                            >
                                <AllChangeRequests setCRStatus={setCRStatus} />
                            </TabPanel>
                            <TabPanel
                                sx={{
                                    pr: 0,
                                    pl: 0,
                                    pt: 0,
                                }}
                                value={'approval-requests'}
                            >
                                <ApproverChangeRequests setCRStatus={setCRStatus} />
                            </TabPanel>
                        </TabContext>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default ChangeRequests;
